<template>
  <div>
    <!-- 新闻中心 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link to="/newsCenter">新闻中心 </router-link>
        </div>
        <div class="page-center-box w-100">
          <div class="page-left">
            <div class="box-info1 w-100">新闻中心</div>
            <div class="box-info2 w-100">
              <span
                :class="{ active: newActive === item.type }"
                :key="item.label"
                v-for="(item, index) in nesList"
                @click="refresh(item)"
                >{{ item.label }}</span
              >
            </div>
          </div>
          <div class="page-right">
            <div class="news-list w-100">
              <ul>
                <li v-for="(item, index) in currentPageData" :key="index" style="display: flex;justify-content: space-between; align-items: center;">
                  <router-link
                    :to="{
                      path: '/newsDetails',
                      query: {
                        id: item.id,
                        type: newActive,
                        pageIndex: currentPage,
                        index,
                      },
                    }"
                    style="display: flex;justify-content: space-between; align-items: center;width: 100%;"
                  >
                    <span>{{ item.title }}</span>
                    <!-- <i>{{ item.releaseTime }}</i>
                    <p>{{ item.desc_ }}</p> -->
                    <span style="font-weight: 400; display: inline-block;width: 200px;text-align: right;" class="text-one-hide">
                      {{ getDate(item.lastTime) }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="fanye w-100 gray">
              <div class="center-center">
                <ul class="between-center">
                  <li @click="prevPage">
                    <a href="javascript:;">&lt;</a>
                  </li>
                  <li
                    v-for="(item, index) in pageList"
                    :key="index"
                    @click="pageListClick(index)"
                  >
                    <a
                      :class="{ active: currentPage == index + 1 }"
                      href="javascript:;"
                      >{{ item }}</a
                    >
                  </li>
                  <li @click="nextPage">
                    <a href="javascript:;">&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMessageListMore
} from '@/common/http.js'
export default {
  name: 'newsCenter',
  data () {
    return {
      articleArry: [],
      newsColumnId: '',
      totalPage: 1,	//总页数
      currentPage: 1,	//当前页数
      pageSize: 10,	//每页显示数量
      currentPageData: [],//处理过后的数据,
      nesList: [
        {
          label: '通知公告',
          type: 1
        },
        {
          label: "新闻资讯",
          type: 5
        }
      ],
      newActive: 1,
    }
  },
  mounted () {
    let that = this;
    this.newActive = this.$route.query.id * 1;
    this.newsArticle();
  },
  computed: {
    pageList () {
      return Math.ceil(this.totalPage / this.pageSize);
    },
    getDate() {
      return (e) => {
        if (e) {
          const s = e.split(' ')
          return s[0] || e
        }
        return e
      }
    }
  },
  methods: {
    newsArticle () {
      getMessageListMore({
        pageSize: this.pageSize,
        pageIndex: this.currentPage,
        type: this.newActive,
      }).then(res => {
        if (res.result) {
          this.currentPageData = res.data.rows;
          this.totalPage = res.data.total;
        }
      })
    },
    refresh (item) {
      // this.$router.go(0);
      this.newActive = item.type;
      this.newsArticle();
    },
    change (item, index) {
      // 保存当前新闻所在位置和页码
      console.log(item, index);
    },
    //上一页
    prevPage () {
      if (this.currentPage == 1) {
        this.$message.error("没有上一页了")
        return;
      }
      this.currentPage--;
      this.newsArticle();
    },
    // 下一页
    nextPage () {
      if (this.currentPage * this.pageSize > this.totalPage) {
        this.$message.error("没有下一页了")
        return;
      };
      this.currentPage++;
      this.newsArticle();
    },
    pageListClick (index) {
      this.currentPage = index + 1;
      this.newsArticle();
    }
  }
}

</script>

<style>
.text-one-hide{ overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1;}
</style>



// WEBPACK FOOTER //
// src/pages/newsCenter/newsCenter.vue